/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_User_Role_ErrorInputs */

const vi_toast_user_role_error = /** @type {(inputs: Toast_User_Role_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật vai trò thất bại`)
};

/**

* @param {Toast_User_Role_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_user_role_error = /** @type {((inputs?: Toast_User_Role_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_User_Role_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_user_role_error(inputs)
});